import React from 'react';
import Paper from "@material-ui/core/Paper/index";
import {Button} from 'primereact/button';
import {Divider} from "@material-ui/core";
import {Checkbox} from 'primereact/checkbox';
import TitlePage from "../../../../app/Title/TitlePage/TitlePageView";
import LinearProgress from "@material-ui/core/LinearProgress";
import {Dropdown} from "primereact/dropdown";
import DateFnsUtils from "@date-io/date-fns";
import {KeyboardTimePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import SubtitleLabel from "../../../../app/Title/SubtitleLabel/SubtitleLabelView";
import Grid from "@material-ui/core/Grid";

const ModifyInstitutionScheduleView = (props) => {
    return (
        <React.Fragment>
            <LinearProgress color="secondary" id="LinearProgressBar" hidden={!props.isLoading}/>
            <Paper elevation={5}
                   style={{paddingTop: '1%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%'}}>
                {props.messagesGrowl}
                <Grid container spacing={1}>
                    <Grid item xs={8}>
                        <TitlePage title={"Mantenimiento \\ Horarios \\ Por Institución \\ " + props.pageTitle}/>
                    </Grid>
                    <Grid item xs={4} style={{textAlign: 'right'}}>
                        <Button label="Cancelar" className="p-button-secondary"
                                onClick={props.returnMaintenancePage}/>&nbsp;
                        <Button label="Guardar" onClick={props.saveInstitutionSchedule}/>
                    </Grid>
                    <Grid item xs={12}> <Divider/> </Grid>
                    <Grid item xs={12}>
                        <div className="p-grid">
                            <div className="p-col-12 p-md-6 p-lg-4">
                                <SubtitleLabel header="Institución" isBold={true}/><br/>
                                <Dropdown placeholder="Seleccione..."
                                          name="institution"
                                          filter={true}
                                          required={true}
                                          filterBy="nombreCorto"
                                          optionLabel="nombreCorto"
                                          options={props.institutions}
                                          value={props.institutionObject}
                                          onChange={props.handleChangeValue}/>
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-4">
                                <SubtitleLabel header="Hora Final" isBold={true}/>
                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <KeyboardTimePicker
                                        margin="normal"
                                        name="horaFinal"
                                        mask="__:__"
                                        ampm={false}
                                        keyboardIcon={<AccessTimeIcon/>}
                                        value={props.dataInstitution.horaFinal}
                                        onChange={(event) => props.handleTimeChange("horaFinal", event)}
                                        invalidDateMessage="Horario no válido. Formato 24 horas."/>
                                </MuiPickersUtilsProvider>
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-4">
                                <SubtitleLabel header="Estatus" isBold={true}/> <br/>
                                <Checkbox inputId="tipoCta" value="Activo"
                                          checked={props.activeCheck}
                                          onChange={props.onChangeSelectBox}/>
                                <label htmlFor="tipoCta" className="p-checkbox-label">Activo</label>
                            </div>
                        </div>
                    </Grid>
                </Grid>
            </Paper>
        </React.Fragment>
    )
};

export default /*withStyles(styles)*/(ModifyInstitutionScheduleView);